module.exports = __webpack_public_path__ + "img/ProfileIcon.bd19ee0f.svg";